export var CustomPDFReportOrientation;
(function (CustomPDFReportOrientation) {
    CustomPDFReportOrientation["LANDSCAPE"] = "landscape";
    CustomPDFReportOrientation["PORTRAIT"] = "portrait";
})(CustomPDFReportOrientation || (CustomPDFReportOrientation = {}));
